<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="toGroups" :options="[
                            {value: null, text: $t('selectGroup')},
                            ...groupOptions
                        ]"/>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('subject') }}</div>
            <div class="col-lg-4">{{ $t('desc') }}</div>
            <div class="col-lg-2">{{ $t('toGroups') }}</div>
            <div class="col-lg-3">{{ $t('info') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('name') }}: </b>
              <span>{{ item.title }}</span>
            </div>
            <div class="col-lg-4">
              <b class="c-smart-table__label">{{ $t('desc') }}: </b>
              <span>{{ item.desc }}</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('toGroups') }}: </b>
              <span>{{ getGroupsName(item) }}</span>
            </div>
            <div class="col-lg-3">
              <p v-if="item.createdBy">
                <b>{{ $t('createdBy') }}: </b>
                <span>{{ item.createdBy.name }}</span>
              </p>
              <p>
                <b>{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-select :label="$t('error')" :model="formModel" attribute="error" :errors="formErrors"
                   :options="errorOptions"></form-select>
      <form-input :label="$t('subject')" :model="formModel" attribute="title" :errors="formErrors">
      </form-input>
      <form-textarea row="6" :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors">
      </form-textarea>
      <form-checkbox-group :label="$t('toGroups')" :model="formModel" attribute="toGroups" :errors="formErrors"
                           :options="groupOptions"></form-checkbox-group>
    </b-modal>
  </main>
</template>
<script>
import List from '../mixins/List';
import CRUD from "../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/error-notification',
      defaultFormModel: {
        error: null,
        title: '',
        desc: '',
        toGroups: []
      },
      defaultFilterFormModel: {
        keyword: null,
        toGroups: null
      },
      autoLoad: true,
      errorOptions: [{value: null, text: this.$t('chooseError')}],
      groupOptions: [
        {value: 'van-hanh', text: 'Vận hành'},
        {value: 'bao-loi', text: 'Báo lỗi'},
        {value: 'alert', text: 'Alert'},
        {value: 'gadget-cong-viec', text: 'Gadget công việc'},
      ]
    }
  },
  watch: {
    "formModel.error": function (val) {
      this.formModel.title = val.title;
      this.formModel.desc = val.desc;
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Send notification',
        error: "Error",
        chooseError: "Choose popular error",
        subject: "Subject",
        toGroups: "To groups:",
        createdBy: "Created by",
        selectGroup: "Select group",
      },
      vi: {
        title: 'Gửi thông báo',
        error: "Vấn đề thường gặp",
        chooseError: "Chọn vấn đề thường gặp",
        subject: "Tiêu đề",
        toGroups: "Gửi tới nhóm",
        createdBy: "Tạo bởi",
        selectGroup: "Chọn nhóm",
      }
    }
  },
  methods: {
    getErrorOptions() {
      this.$service.get('/error', {params: {page: 1, pageSize: 100}})
          .then(response => {
            if (response.data && response.data.docs) {
              response.data.docs.forEach(item => {
                this.errorOptions.push({value: item, text: item.title});
              })
            }
          })
    },
    getGroupsName(item) {
      return item.toGroups.reduce((text, value) => {
        let idx = this.groupOptions.findIndex(g => g.value === value);
        if (idx >= 0) {
          if (!text) {
            return this.groupOptions[idx].text;
          }
          return text + ' , ' + this.groupOptions[idx].text;
        }
        return text;
      }, '')
    }
  },
  mounted() {
    this.getErrorOptions();
  }
}
</script>
<style>
select {
  max-width: 466px !important;
}
</style>